// extracted by mini-css-extract-plugin
export default {"logoBox":"index_logoBox_L3ACV","logoImg":"index_logoImg_s71W-","MottoImg":"index_MottoImg_jNgta"};